import hadooop from '../assets/hadooop.png';
import wordpress from '../assets/wordpress.png';

const ExperienceTechs = [
  {
    id: 1,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/html5-colored.svg',
    title: 'HTML',
    style: 'shadow-orange-500',
  },
  {
    id: 2,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/css3-colored.svg',
    title: 'CSS',
    style: 'shadow-blue-500',
  },
  {
    id: 3,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/python-colored.svg',
    title: 'Python',
    style: 'shadow-yellow-400',
  },
  {
    id: 4,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/cplusplus-colored.svg',
    title: 'C++',
    style: 'shadow-red-500',
  },
  {
    id: 5,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/javascript-colored.svg',
    title: 'JavaScript',
    style: 'shadow-yellow-500',
  },
  {
    id: 6,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/react-colored.svg',
    title: 'React',
    style: 'shadow-sky-400',
  },
  {
    id: 7,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/nodejs-colored.svg',
    title: 'Node Js',
    style: 'shadow-lime-400',
  },
  {
    id: 8,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/mysql-colored.svg',
    title: 'My SQL',
    style: 'shadow-sky-500',
  },
  {
    id: 9,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/django-colored.svg',
    title: 'Django',
    style: 'shadow-green-500',
  },
  {
    id: 10,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/figma-colored.svg',
    title: 'Figma',
    style: 'shadow-purple-400',
  },
  {
    id: 11,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/aws-colored-dark.svg',
    title: 'Various AWS',
    style: 'shadow-gray-400',
  },
  {
    id: 12,
    src: hadooop,
    title: 'Hadoop',
    style: 'shadow-sky-400',
  },
  {
    id: 13,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/docker-colored.svg',
    title: 'Docker',
    style: 'shadow-blue-400',
  },
  {
    id: 14,
    src: 'https://raw.githubusercontent.com/danielcranney/readme-generator/main/public/icons/skills/git-colored.svg',
    title: 'Git',
    style: 'shadow-red-400',
  },
  {
    id: 15,
    src: wordpress,
    title: 'Wordpress',
    style: 'shadow-sky-400',
  },
];

export default ExperienceTechs;
